export { default as CompareSection } from './CompareSection';
